<infigo-detail-block [icon]="iconTemplate" [title]="i18n.get('home.search_term_performanceMetrics_lab')">
    <app-skeleton [height]="'70px'" [loading]="loading">
        <div *ngIf="status && performanceData && performanceData.length!==0" class="right-top">
            <app-infigo-select (onChange)="onTimeSegmentChange($event)"
                [options]="timeOpts"
                [value]="timeSegment">
            </app-infigo-select>
        </div>
        <div *ngIf="status &&  performanceData && performanceData.length!==0" class="chart-container">
            <app-performance-chart *ngFor="let data of performanceData;" [data]="data" [loading]="updateLoading"></app-performance-chart>
        </div>
        <div *ngIf="!status">
            <div *ngIf="abnormal"
                class="flex-box">{{i18n.get('monitor.charts_term_repairPerforMonitorData_tip')}}</div>
            <div *ngIf="!abnormal" class="flex-box">
                <h3>{{i18n.get('monitor.charts_term_noConfigPMS_tip1')}}</h3>
                <p class="mt10">
                    <span>{{i18n.get('home.search_term_please_lab')}}</span>
                    <a (click)="jumpToSetMonitor()" style="margin-right: -3px">
                        {{i18n.get('monitor.charts_term_noConfigPMS_tip3')}}
                    </a>{{i18n.get('common.Punctuation_preiod')}}
                </p>
            </div>
        </div>
    </app-skeleton>
</infigo-detail-block>
<ng-template #iconTemplate>
    <svg [nTooltip]="i18n.get('home.search_term_performanceValue_info')" class="icon-tips" nTooltipPlacement="top">
        <use xlink:href="#infigo-question"></use>
    </svg>
</ng-template>
